export enum ApplicationStatusEnum {
    ok = 'OK',
    ko = 'KO',
}
